import React from 'react';
import { Link } from 'react-router-dom';

export default function SiteNav({ active }) {
  return (
    <nav className="qs-nav" aria-label="Main">
      <div className="qs-nav__left">
        <Link to="/" className="qs-brand">Qutron</Link>
        <div className="qs-nav__links">
          <Link to="/" className={active === 'home' ? 'is-active' : undefined} aria-current={active === 'home' ? 'page' : undefined}>Home</Link>
          <Link to="/About" className={active === 'about' ? 'is-active' : undefined} aria-current={active === 'about' ? 'page' : undefined}>About</Link>
        </div>
      </div>
      <a className="qs-btn" href="https://lab.qutron.co"><span className="qs-btn__long">Sign in to the lab</span><span className="qs-btn__short">Lab</span></a>
    </nav>
  );
}
